export const TYPES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
}
